import React from "react";
import '../styles/Success.css';
import payment from '../assets/images/success-image.png';
const Success = (props) => {
    return (
        <div className="success-component animate">
            <div className="image-container-success">
                <img src={payment} alt="success" />
            </div>
            <div className="main-text">
                Thank You
            </div>
            <div className="patient-detail">
                <div>Your pre-registration is complete.</div>
                <div className="bold">Your queue number is {props.queueNo}</div>
            </div>
            <div className="after-btns-container">
                <button onClick={()=>{window.location.href='/'}}>Register Again</button>
            </div>
        </div>
    )
}
export default Success;